import Vue from "vue";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueHotkey from "v-hotkey";
import router from "./router";
import store from "@/stores/store";
import { hideStartupLoaderAfterFirstPaint } from "@/services/StartupLoader";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@/style/theme-tokens.css";
Vue.config.productionTip = false;

Vue.use(VueHotkey);
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
  mounted() {
    hideStartupLoaderAfterFirstPaint(this);
  },
}).$mount("#app");
